module.exports = __webpack_public_path__ + "error.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/error.png
// module id = 2182
// module chunks = 13